import axiosInstance from "../../../helpers/api";

export const listAttendenceForStudent = (name) => {
  return axiosInstance.get("/admin/attendance/list_for_student", {
    params: { name },
  });
};

export const deleteAttendence = (id) => {
  return axiosInstance.delete(`/admin/attendance/${id}`);
};
